/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Student {
    angular.module("meevo.plugins.student", []);
}